<i18n lang="yaml" locale="en">
  asset browser: Asset Browser
  add folder: Add folder
  name: Name
  enter folder name: Please enter the folder name.
</i18n>

<i18n lang="yaml" locale="de">
  asset browser: Asset Browser
  add folder: Ordner hinzufügen
  name: Name
  enter folder name: Bitte geben Sie den Namen des Ordners an.
</i18n>

<template>
  <div
    v-if="$editMode"
    class="browser"
    :class="{ active }"
  >
    <div
      class="slide-icon"
      @click="toggleSelf"
    >
      <chevron-circle
        size="s"
        color="success"
        :active="active"
        :rotate="180"
      />
    </div>
    <div class="heading">
      <span class="title">
        {{ $t('asset browser') }}
      </span>
    </div>
    <tw-button
      icon="add-circle"
      color="main"
      class="btn-add-folder"
      block
      @click="openNewFolderPrompt"
    >
      {{ $t('add folder') }}
    </tw-button>
    <folder
      :path="path"
      name="rootFolder"
      root
      class="scroll-y"
    >
      <component
        v-for="child in children"
        :key="child.getters.path"
        :path="child.getters.path"
        :is="child.getters.type"
        v-bind="child.getters.props"
      />
    </folder>
  </div>
</template>

<script>
import { Prompt } from '@/plugins/snotify'
import TwButton from '@/components/ui/TwButton'
import ChevronCircle from '@/components/icons/ChevronCircle'
import Folder from '@/components/modules/Folder'
import BaseModule from '@/components/modules/BaseModule'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'assets',
  extends: BaseModule,
  components: {
    ChevronCircle,
    TwButton,
    Folder
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
  },
  methods: {
    openNewFolderPrompt (path) {
      new Prompt(this.$t('name'), this.$t('enter folder name'), this.addFolder).open()
    },
    addFolder (name) {
      this.$store.dispatch('addChild', {
        childType: 'folder',
        props: {
          name: name
        }
      })
    },
    toggleSelf () {
      this.active = !this.active
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.browser {
  width: 380px;
  height: 100vh;
  padding: 30px 20px;
  background-color: rgba($color: $color-main-darker, $alpha: 0.98);
  position: fixed;
  right: -380px;
  top: 0px;
  transition: right 250ms ease-in-out;
  font-size: 14px;
  letter-spacing: 0.25pt;
  font-weight: 400;
  box-shadow: 0 0 20px rgba(#000, 0.5);
  display: flex;
  flex-direction: column;
  z-index: z(assetEditor);

  &.active {
    right: 0; /* needs to be done without translate, to not reset the fixed container */
  }

  .heading {
    display: flex;
    padding: 20px;
    background-color: darken($color-main-darker, 5);
    font-weight: 600;
    text-transform: uppercase;
    margin: -30px -20px 30px -20px;

    .title {
      color: $color-main;
    }
  }

  .slide-icon {
    display: block;
    position: absolute;
    padding: 8px;
    top: 50%;
    left: -40px;
    background-color: rgba($color: $color-main-darker, $alpha: 0.98);
    transition: 250ms ease-in-out;
    transform: translateY(-50%);
    line-height: 0;
    border-radius: 50% 0% 0% 50%;
  }

  .btn-add-folder {
    justify-content: flex-start;
    margin-bottom: 1.5rem;
  }
}
</style>
